import { useCallback } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import {
  useCreate,
  useNotify,
  SimpleForm,
  Create,
  useResourceContext,
  useRefresh,
  FileInput,
  FileField,
  useTranslate,
} from "react-admin";
import SaveDeleteBtns from "../../saveDeleteBtns/SaveDeleteBtn";
import UploadProgress from "../../uploadProgresses/UploadProgress";

export default function CloseBookUploadDialog({ open, setOpen }) {
  const [create, { isLoading: isCreateLoading }] = useCreate();
  const notify = useNotify();
  const refresh = useRefresh();
  const t = useTranslate();
  const resource = useResourceContext(); // cuman nama resource

  const save = useCallback(
    async (values) => {
      try {
        await create(
          resource + "/upload",
          { data: values },
          {
            returnPromise: true,
            onSuccess: (data) => {
              notify("ra.notification.created", {
                messageArgs: { smart_count: 1 },
              });
              setOpen(false);
              refresh();
            },
          }
        );
      } catch (error) {
        if (error.message) {
          notify(error.message, {
            type: "error",
          });
        }
      }
    },
    [create]
  );

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog open={open} onClose={handleClose} keepMounted={false}>
      <Create title={" "} sx={{ "& .RaCreate-main": { mt: 0 } }}>
        <SimpleForm
          warnWhenUnsavedChanges
          onSubmit={save}
          toolbar={<SaveDeleteBtns />}
          mode="onBlur"
          reValidateMode="onBlur"
        >
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              pt: 0,
            }}
          >
            <DialogTitle>
              {t("mine.label.upload") + " " + t("resources.close_book.name")}
            </DialogTitle>
            <IconButton onClick={handleClose} sx={{ mr: "11px" }}>
              <CloseIcon />
            </IconButton>
          </Box>
          <DialogContent>
            <FileInput
              source="file"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            >
              <FileField source="src" title="title" />
            </FileInput>
          </DialogContent>
        </SimpleForm>
      </Create>
      <UploadProgress isCreateLoading={isCreateLoading} />
    </Dialog>
  );
}
